// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__16L42","row":"styles_row__34lyx"};